<template>
    <!-- start navigator -->
    <div class="container ps-lg-5 pe-lg-5 mt-1">
        <div class="row">
            <div class="
            col-12
            d-none d-lg-flex
            justify-content-between
            align-items-center
          ">
                <nav style="--bs-breadcrumb-divider: '>'" aria-label="breadcrumb">
                    <ol class="breadcrumb">
                        <li class="breadcrumb-item">
                            <router-link class="text-decoration-none router-link"
                                to="/AgenteService">หน้าแรก</router-link>
                        </li>
                        <li class="breadcrumb-item" aria-current="page">
                            <router-link class="text-decoration-none router-link"
                                to="/AgenteService">ข้อมูลยื่นคำร้อง</router-link>
                        </li>
                        <li class="breadcrumb-item router-link active">
                            ขอต่ออายุใบอนุญาต
                        </li>
                    </ol>
                </nav>
            </div>
        </div>
    </div>
    <!-- end navigator -->

    <div class="container-lg">
        <div class="row">
            <!-- Left Menu -->
            <div class="col-left-menu">
                <div class="left-menu">
                    <ul class="d-none d-lg-block">
                        <Menu />
                    </ul>
                </div>
            </div>
            <!-- Left Menu -->

            <div class="
          col-left-menu
          d-flex d-lg-none
          border-bottom
          align-items-center
          border-bottom
          w-100
          ps-3
          pe-3
        " style="background-color: #f2f2f2">
                <div class="icon-back">
                    <router-link to="/AgenteService">
                        <img src="@/assets/images/arrow-blue.svg" class="w-100" />
                    </router-link>
                </div>
                <div class="title ps-md-3 ps-lg-3 d-block d-lg-none text-center w-100 font-family blue-1">
                    ขอต่ออายุใบอนุญาต
                </div>
            </div>

            <div class="col">

                <StepBar :steps="['ตรวจสอบข้อมูล', 'อัปโหลดเอกสาร', 'ยืนยันการทำรายการ', 'ชำระเงิน', 'เสร็จสิ้น']"
                    :current="0" />

                <div class="title d-none d-lg-block border-bottom font-family blue-1">
                    ขอต่ออายุใบอนุญาต
                </div>

                <div class="font-family-bla my-3">
                    <div class="card-wrap p-4">
                        <h4 class="text-center fw-bold mb-4">ตรวจสอบข้อมูลผู้ยื่นคำร้อง<br>
                            ขอต่ออายุใบอนุญาตเป็นตัวแทนประกันชีวิต ครั้งที่ {{ dataResp.requestAgentRenewLicenseNo }}
                        </h4>

                        <!-- แสดงเฉพาะกรณีที่เป็น ต่อ 4 -->
                        <label v-if="dataResp.requestAgentRenewLicenseNo === 4" class="col-form-label-lg">
                            เงื่อนไขในการขอต่อใบอนุญาตฯ ครั้งที่ 4 เป็นต้นไป ท่านต้องมีชั่วโมงอบรมครบ 30 ชั่วโมง
                            กรณีมีวุฒิ ป.โท หรือ มีคุณวุฒิตามที่ คปภ.กำหนด
                            <span class="text-primary">
                                (FChFP, CFP, AFPT, Diploma in Non-Life Insurance (วินาศภัย), Cert. CII (วินาศภัย),
                                ANZIIF, FLMI , ALMI , วิทยากร)
                            </span>
                            <br>ท่านสามารถ
                            <span class="text-primary text-decoration-underline">ยื่นเอกสาร</span>
                            เพื่อขอใช้สิทธิลดหย่อนชั่วโมงอบรมได้ 15 ชั่วโมง ที่ฝ่ายฝึกอบรมช่องทางการขาย
                            กรุณาดำเนินการยื่นลดหย่อนชั่วโมงอบรมก่อนการยื่นขอต่ออายุใบอนุญาตฯ ออนไลน์ล่วงหน้าอย่างน้อย
                            <span class="text-primary"> 15 </span>
                            วัน มิเช่นนั้นจะถือว่าท่านสละสิทธิ์ในการลดหย่อนชั่วโมงอบรม
                        </label>

                        <form @submit.prevent="onSubmit">
                            <!-- ชื่อ-สกุล -->
                            <div class="row g-2 align-items-center mb-3">
                                <label class="col-12 col-md-4 col-form-label-lg text-start">ชื่อ-สกุล</label>
                                <div class="col-12 col-md-8">
                                    <input class="form-control" v-model="dataResp.dataPreview.fullName" readonly
                                        disabled />
                                </div>
                            </div>

                            <!-- เลขประจำตัวประชาชน -->
                            <div class="row g-2 align-items-center mb-3">
                                <label class="col-12 col-md-4 col-form-label-lg text-start">เลขประจำตัวประชาชน</label>
                                <div class="col-12 col-md-8">
                                    <input class="form-control" v-model="dataResp.dataPreview.idCard" readonly
                                        disabled />
                                </div>
                            </div>

                            <!-- ที่อยู่ตามทะเบียนบ้าน -->
                            <div class="row g-2 align-items-center mb-3">
                                <label
                                    class="col-12 col-md-4 col-form-label-lg text-start">ที่อยู่ตามทะเบียนบ้าน</label>
                                <div class="col-12 col-md-8">
                                    <textarea class="form-control" rows="2" v-model="dataResp.dataPreview.address"
                                        readonly disabled></textarea>
                                </div>
                            </div>

                            <!-- ที่อยู่ที่ติดต่อได้ -->
                            <div class="row g-2 align-items-center mb-3">
                                <label class="col-12 col-md-4 col-form-label-lg text-start">ที่อยู่ที่ติดต่อได้</label>
                                <div class="col-12 col-md-8">
                                    <textarea class="form-control" rows="2"
                                        v-model="dataResp.dataPreview.contactAddress" readonly disabled></textarea>
                                </div>
                            </div>

                            <!-- เบอร์โทรศัพท์ -->
                            <div class="row g-2 align-items-center mb-3">
                                <label class="col-12 col-md-4 col-form-label-lg text-start">เบอร์โทรศัพท์</label>
                                <div class="col-12 col-md-8">
                                    <input class="form-control" v-model="dataResp.dataPreview.phone" readonly
                                        disabled />
                                </div>
                            </div>

                            <!-- อีเมล -->
                            <div class="row g-2 align-items-center mb-3">
                                <label class="col-12 col-md-4 col-form-label-lg text-start">อีเมล</label>
                                <div class="col-12 col-md-8">
                                    <input class="form-control" v-model="dataResp.dataPreview.email" readonly
                                        disabled />
                                </div>
                            </div>

                            <div class="" v-if="dataResp.isRegisUnitLink">

                                <div class="row">
                                    <!-- ผู้แนะนำการลงทุนด้าน -->
                                    <div class="col-12 col-md-6">
                                        <div class="inline-field">
                                            <label class="col-form-label-lg">ผู้แนะนำการลงทุนด้าน</label>
                                            <div class="inline-control">
                                                <label class="form-control-plaintext"
                                                    v-text="dataResp.dataPreview.advisor"></label>
                                            </div>
                                        </div>
                                    </div>

                                    <!-- เลขที่ทะเบียน -->
                                    <div class="col-12 col-md-6">
                                        <div class="inline-field">
                                            <label class="col-form-label-lg">เลขที่ทะเบียน</label>
                                            <div class="inline-control">
                                                <label class="form-control-plaintext"
                                                    v-text="dataResp.dataPreview.registerId"></label>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="row">
                                    <!-- วันที่ได้รับความเห็นชอบ -->
                                    <div class="col-12 col-md-6">
                                        <div class="inline-field">
                                            <label class="col-form-label-lg">วันที่ได้รับความเห็นชอบ</label>
                                            <div class="inline-control">
                                                <label class="form-control-plaintext"
                                                    v-text="dataResp.dataPreview.approvalDate"></label>
                                            </div>
                                        </div>
                                    </div>

                                    <!-- วันหมดอายุ -->
                                    <div class="col-12 col-md-6">
                                        <div class="inline-field">
                                            <label class="col-form-label-lg">วันหมดอายุ</label>
                                            <div class="inline-control">
                                                <label class="form-control-plaintext"
                                                    v-text="dataResp.dataPreview.approvalDate"></label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <!-- หมายเหตุ -->
                            <div class="text-muted bg-body-tertiary">
                                กรณีตรวจสอบแล้วพบว่าข้อมูลไม่ถูกต้องหรือต้องการแก้ไขข้อมูล ท่านต้องทำรายการยื่นคำร้อง
                                e-Request เพื่อขอแก้ไขข้อมูลตัวแทนและต้องได้รับอนุมัติเรียบร้อยแล้ว
                                จึงจะสามารถดำเนินการต่อไปได้
                                มิเช่นนั้นจะทำให้เอกสารคำขอต่ออายุใบอนุญาตตัวแทนประกันชีวิตผิดพลาดและไม่สามารถทำรายการต่ออายุได้
                                <a href="#" @click.prevent="$router.replace('/AgentInfo')">
                                    คลิกที่นี่เพื่อเข้าสู่การยื่นคำร้องขอแก้ไขข้อมูลตัวแทน
                                </a>
                                <br>หากมีข้อสงสัยกรุณาติดต่อส่วนสัญญาตัวแทน โทร. 02-777-8560,8567 ในเวลาทำการ จันทร์ -
                                ศุกร์ เวลา 08.30 น. - 17.00 น.
                            </div>

                            <!-- ปุ่ม -->
                            <div class="text-center mt-4">
                                <button type="submit" class="btn btn-bla btn-confirm">
                                    ยืนยันข้อมูล
                                </button>
                            </div>
                        </form>
                    </div>
                </div>

            </div>

        </div>
    </div>

    <div v-if="this.Loading">
        <LoadingBs5></LoadingBs5>
    </div>
</template>

<script>
import Menu from "@/components/agenteservice/Menu.vue";
import { faCircleXmark } from "@fortawesome/free-solid-svg-icons";

import LoadingBs5 from "@/components/frontend/LoadingBs5";
import http from "@/services/AuthService";
import Swal from 'sweetalert2/src/sweetalert2.js'
import { openUnitLinkedPopup } from '@/utils/unitlinked-popup' // ไฟล์ที่วางฟังก์ชันด้านบนนี้
import { openPrivacyPopup } from '@/utils/privacy-popup' // ปรับ path ให้ตรงที่วางไฟล์

import StepBar from "./StepBar.vue";

import '@/styles/SweetAlert2CustomCSS.css';

export default {
    name: "PreviewAgentRenewLicense",
    components: {
        Menu,
        LoadingBs5,
        StepBar
    },
    data() {
        return {
            faCircleXmark: faCircleXmark,
            Loading: true,
            dataResp: {
                isRegisUnitLink: false,// แสดง ตรวจสอบว่ามีสิทธิ์ผู้ขึ้นทะเบียนขาย Unit-Linked ถ้าไม่มี = false
                requestAgentRenewLicenseNo: 0,// ต่ออะไร
                dataPreview: {
                    fullName: '',
                    idCard: '',
                    address: '',
                    contactAddress: '',
                    phone: '',
                    email: '',
                    advisor: '',
                    registerId: '',
                    approvalDate: '',
                    expireDate: ''
                },
            },
            isRenewAgentRegis: false,
        };
    },
    mounted() {
        if (this.$store.state.AgentCode == '') {
            this.$router.push('/');
        }

        this.Authorization();

        this.BindingData();
    },
    methods: {
        BindingData() {
            // Call APi
            let AuthorizeToken = localStorage.getItem("AuthorizeToken");
            http.get(`AgencyERequest/GetPreviewAgentRenewLicense`, { headers: { Authorization: `Bearer ${AuthorizeToken}` } }).then((response) => {
                this.Loading = false;

                if (response.status === 200) {
                    this.dataResp = response.data;
                    this.$store.state.AgentRenewLicense.preview.dataResp = response.data;
                }
                else {
                    localStorage.removeItem("Token");
                    localStorage.removeItem("AuthorizeToken");
                    window.open(process.env.VUE_APP_URL_ADFS + "AgencyERequestConvertor", '_self');
                }
            }).catch((error) => {
                this.Loading = false;
                Swal.fire({
                    icon: 'error',
                    html: '<label class="fs-4 fw-normal font-family">' + error.response.data.ErrorMessage + '</label>',
                }).then(() => {
                    localStorage.removeItem("Token");
                    localStorage.removeItem("AuthorizeToken");
                    window.open(process.env.VUE_APP_URL_ADFS + "AgencyERequestConvertor/Logout", '_self');
                });
            });
        },
        async onSubmit() {
            const canProceed = await this.Authentication('L01');
            if (!canProceed) {
                return; // หยุดการทำงานถ้ามีเอกสารอยู่แล้ว
            }
 
            let isCheckUnitLinkedPopup = false;// popup unitlink มีการกดแล้ว?
            if (this.dataResp.isRegisUnitLink) {
                const res = await openUnitLinkedPopup(); //  ต้องการต่ออายุการขึ้นทะเบียนตัวแทนประกันชีวิตควบการลงทุน (Unit Linked) ด้วยหรือไม่?
                isCheckUnitLinkedPopup = true;

                if (res.isConfirmed) {
                    this.isRenewAgentRegis = true;
                } else {
                    this.isRenewAgentRegis = false;
                }
            }

            if (!this.dataResp.isRegisUnitLink || (this.dataResp.isRegisUnitLink && isCheckUnitLinkedPopup)) {
                const privacyRes = await openPrivacyPopup('PN_AgencyERequest');
                if (privacyRes.isConfirmed) {
                    this.$store.state.AgentRenewLicense.ConsentBySiteCode.ACCEPT_CONFIRM = 'Y';// Flag การรับทราบคำรับรองประกาศความเป็นส่วนตัว  Y = รับทราบ N = ไม่รับทราบ

                    const payload = {
                        consentCode: this.$store.state.AgentRenewLicense.ConsentBySiteCode.ConsentCode
                    };
                    let AuthorizeToken = localStorage.getItem("AuthorizeToken");
                    http.post(`AgencyERequest/AcceptConsentAgent`, payload, { headers: { Authorization: `Bearer ${AuthorizeToken}` } }).then((response) => {
                        this.$store.state.AgentRenewLicense.ConsentBySiteCode.ACCEPT_CONFIRM_DT = new Date().toLocaleString('th-TH');
                    }).catch((error) => {
                        Swal.fire({
                            icon: 'error',
                            html: `<label class="fs-4 fw-normal font-family">${error.response.data.ErrorMessage}</label>`,
                            customClass: {
                                popup: 'swal-wide',
                                confirmButton: 'btn-bla btn-pill'
                            }
                        });
                    });

                    await this.verifyAgentStatus();
                }
            }

        },
        // ===== ฟังก์ชันตรวจสอบหลังยอมรับ Privacy =====
        async verifyAgentStatus() {
            try {
                this.Loading = true;

                const checkHasRisk = await this.apiCheckHasRisk();
                if (!checkHasRisk?.verifyDetail) {
                    Swal.fire({
                        icon: "error",
                        title: "เกิดข้อผิดพลาด",
                        text: "ไม่สามารถดำเนินการได้ กรุณาลองใหม่อีกครั้งหรือติดต่อผู้ดูแลระบบ",
                        // confirmButtonText: "ตกลง"
                        customClass: {
                            popup: 'swal-wide',
                            confirmButton: 'btn-bla btn-pill'
                        }
                    });
                    return; // หยุดต่อถ้าไม่มีข้อมูล
                }

                // สรุปผล
                const failed = [];
                if (checkHasRisk.verifyDetail.hasBankRupt) failed.push('ล้มละลาย');
                if (checkHasRisk.verifyDetail.hasCDD) failed.push('ฟอกเงิน');
                if (checkHasRisk.verifyDetail.deathStatus != null
                    && checkHasRisk.verifyDetail.deathStatus !== 'AL') {
                    failed.push('เสียชีวิต');
                }

                if (failed.length > 0) {
                    // มีบางเงื่อนไขไม่ผ่าน
                    Swal.fire({
                        icon: "error",
                        title: "คำเตือน",
                        html: `ท่านไม่สามารถดำเนินการต่อไปได้ เนื่องจากคุณสมบัติไม่เป็นไปตามเงื่อนไข 
                        <br> กรุณาติดต่อส่วนสัญญาตัวแทน อีเมล : <a href="mailto:agentcontract@bangkoklife.com">agentcontract@bangkoklife.com</a>
                        <br> โทรศัพท์ : 02-777-8560,8567
                        <br> (ในเวลาทำการ จันทร์-ศุกร์ เวลา 08:30-17:00 น.)`,
                        // confirmButtonText: "ปิด",
                        allowOutsideClick: false,
                        allowEscapeKey: false,
                        allowEnterKey: false,
                        customClass: {
                            popup: 'swal-wide',
                            confirmButton: 'btn-bla btn-pill'
                        }
                        // customClass: {
                        //     popup: 'swal-wide swal-font',
                        //     confirmButton: 'btn btn-secondary'
                        // }
                    }).then(() => {
                        // Clear ข้อมูลเก่าออกและ Redirect
                        this.$router.replace('/AgenteService');
                    });
                } else {
                    // ผ่านทุกเงื่อนไข → ไปหน้าถัดไป
                    this.$store.state.AgentRenewLicense.preview.isRegisUnitLink = this.dataResp.isRegisUnitLink;
                    this.$store.state.AgentRenewLicense.preview.isRenewAgentRegis = this.isRenewAgentRegis;

                    this.$router.replace('/Tc7Certification');
                }

            } catch (err) {
                Swal.fire({
                    icon: 'error',
                    title: 'เกิดข้อผิดพลาด',
                    text: err?.message || 'ไม่สามารถตรวจสอบได้',
                    customClass: {
                        popup: 'swal-wide',
                        confirmButton: 'btn-bla btn-pill'
                    }
                });
            } finally {
                this.Loading = false;
            }
        },
        // ====== ตัวอย่าง API wrappers (แก้ endpoint/รูปแบบตามจริง) ======
        async apiCheckHasRisk() {// 1.ตรวจสอบ DOPA สถานะการมีชีวิต 2.ตรวจสอบล้มละลาย 3.ตรวจสอบฟอกเงิน
            let AuthorizeToken = localStorage.getItem("AuthorizeToken");
            try {
                const response = await http.get(`AgencyERequest/CheckHasRisk`, {
                    headers: { Authorization: `Bearer ${AuthorizeToken}` }
                });

                if (response.status === 200) {
                    return response.data;
                } else {
                    Swal.fire({
                        icon: 'error',
                        html: `<label class="fs-4 fw-normal font-family">${response.data.ErrorMessage}</label>`,
                        customClass: {
                            popup: 'swal-wide',
                            confirmButton: 'btn-bla btn-pill'
                        }
                    });
                    return null;
                }
            } catch (error) {
                Swal.fire({
                    icon: 'error',
                    html: `<label class="fs-4 fw-normal font-family">${error.response?.data?.ErrorMessage || 'เกิดข้อผิดพลาด'}</label>`,
                    customClass: {
                        popup: 'swal-wide',
                        confirmButton: 'btn-bla btn-pill'
                    }
                });
                return null;
            }
        },
        async Authentication(SUBJOB) {
            try {
                const AuthorizeToken = localStorage.getItem("AuthorizeToken");
                const request = {
                    AGENTCODE: [],
                    SUBJOB: SUBJOB
                };

                const res = await http.post("AgencyERequest/CheckCreateJob?", request, { headers: { Authorization: `Bearer ${AuthorizeToken}` } });

                if (res.data === '001' || res.data === '002') {
                    Swal.fire({
                        icon: 'error',
                        html: '<label class="fs-4 fw-normal font-family">ไม่สามารถทำรายการนี้ได้ เนื่องจากมีการร้องของานไปแล้วก่อนหน้า</label>',
                    }).then(() => {
                        this.$router.replace('/AgenteService');
                    });
                    return false; // มีเอกสารอยู่แล้ว
                }

                console.log('ยังไม่มีเอกสารที่สร้างไปก่อนหน้า');
                return true; // สามารถดำเนินการต่อได้

            } catch (error) {
                console.error(error);
                Swal.fire({
                    icon: 'error',
                    html: '<label class="fs-4 fw-normal font-family">เกิดข้อผิดพลาดของระบบ</label>',
                }).then(() => {
                    this.$router.replace("/AgenteService");
                });
                return false; // ไม่สามารถดำเนินการต่อได้
            }
        },
        Authorization() {
            this.Loading = true;

            let AuthorizeToken = localStorage.getItem("AuthorizeToken");
            http.get("AgencyERequest/GetName", { headers: { Authorization: `Bearer ${AuthorizeToken}` } }).then((response) => {
                if (response.status == 200) {
                    this.Loading = false;

                    this.$store.state.UserName = response.data.NAME + " " + response.data.SURNAME;
                    this.$store.state.AgentCode = response.data.AGENTCODE;
                }
                else {
                    localStorage.removeItem("Token");
                    localStorage.removeItem("AuthorizeToken");
                    window.open(process.env.VUE_APP_URL_ADFS + "AgencyERequestConvertor", '_self');
                }
            }).catch((error) => {
                Swal.fire({
                    icon: 'error',
                    html: '<label class="fs-4 fw-normal font-family">' + error.response.data.ErrorMessage + '</label>',
                }).then(() => {
                    localStorage.removeItem("Token");
                    localStorage.removeItem("AuthorizeToken");
                    window.open(process.env.VUE_APP_URL_ADFS + "AgencyERequestConvertor/Logout", '_self');
                });
            });
        },
    },
};

</script>

<style scoped>
/* โทนฟอนต์และกรอบให้เหมือน template ที่ให้มา */
.font-family-bla {
    font-family: "DB Heavent", sans-serif;
}

.card-wrap {
    border: 2px solid #A2B9E2;
    border-radius: 10px;
    background: #fff;
}

/* ให้ตัวอักษรของ input/textarea readonly & disabled เป็นสี #6D8EC9 */
.form-control[readonly],
textarea[readonly],
.form-control:disabled,
textarea:disabled,
.form-control-plaintext {
    color: #6D8EC9 !important;
    /* background-color: var(--bs-body-tertiary) !important; */
    cursor: default;
}

/* ปุ่ม: เต็มความกว้างบนมือถือ และกว้างพอดีบนจอใหญ่ */
.btn-confirm {
    width: 100%;
}

@media (min-width: 768px) {
    .btn-confirm {
        width: 25%;
        min-width: 160px;
        max-width: 320px;
    }
}

/* กรอบแดงไม่มี bg */
.alert-red-border {
    border: 2px solid var(--bs-danger);
    border-radius: 10px;
}

/* ===== Inline label + control ===== */
.inline-field {
    --label-w: 9.5rem;
    /* ปรับความกว้าง label ได้ตามต้องการ */
    display: flex;
    align-items: center;
    gap: .75rem;
}

.inline-label {
    flex: 0 0 var(--label-w);
    max-width: 50%;
    font-weight: 600;
}

.inline-control {
    flex: 1 1 auto;
    min-width: 0;
    /* กัน overflow */
}

/* มือถือ: ซ้อนเป็นแนวตั้งให้ใช้งานง่าย */
@media (max-width: 575.98px) {
    .inline-field {
        flex-direction: column;
        align-items: stretch;
    }

    .inline-label {
        flex: 0 0 auto;
        max-width: 100%;
    }
}
</style>
